import { createSelector } from "reselect";
import { getWorkflowsState } from "./root-selectors";
import { WorkflowsState } from "@idw-types/state/workflows-state";

export const getWorkflowsDataState = createSelector(getWorkflowsState, (state: WorkflowsState) => {
	return {
        isLoadingWorkflowConfigurations: state.workflowConfigurations.isLoading,
        workflowConfigurations: state.workflowConfigurations.workflowConfigurations
    };
});